module.exports = __webpack_public_path__ + "img/EG.fe0113cb.webp";